"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useAttributesWithDrillDown = exports.AttributesWithDrillDownProvider = void 0;
var tslib_1 = require("tslib");
// (C) 2020 GoodData Corporation
var react_1 = tslib_1.__importDefault(require("react"));
var AttributesWithDrillDownContext = react_1.default.createContext([]);
AttributesWithDrillDownContext.displayName = "AttributesWithDrillDownContext";
/**
 * @internal
 */
exports.AttributesWithDrillDownProvider = function (_a) {
    var children = _a.children, attributes = _a.attributes;
    return (react_1.default.createElement(AttributesWithDrillDownContext.Provider, { value: attributes }, children));
};
/**
 * @internal
 */
exports.useAttributesWithDrillDown = function () {
    return react_1.default.useContext(AttributesWithDrillDownContext);
};
//# sourceMappingURL=AttributesWithDrillDownContext.js.map